import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import {Bot} from "../../models/bot";
import {DataMapping} from "../../models/data-mapping";
import Helpers from "../../utils/helpers";

@Injectable()
export class BotControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getServiceBots(serviceId: string): Observable<Bot[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/bot") as Observable<Bot[]>;
  }

  public getServiceValidationBots(serviceId: string): Observable<Bot[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/bot?validationBots=true") as Observable<Bot[]>;
  }

  public getServicePrintingBots(serviceId: string): Observable<Bot[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/bot?printingBots=true") as Observable<Bot[]>;
  }

  public getAllBots(serviceId: string, componentKey: string, showSystemBots: boolean): Observable<Bot[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/bot?systemBots=" + showSystemBots + (componentKey ? "&componentKey=" + componentKey : "")) as Observable<Bot[]>;
  }

  public getBot(botId: string): Observable<Bot> {
    return this.http.get(this.baseUrl + "bot/" + botId) as Observable<Bot>;
  }

  public cloneBot(bot: Bot) {
    Helpers.trimRecursiveObj(bot);
    const body = JSON.stringify(bot);
    return this.http.post(this.baseUrl + "bot/" + bot.id + "/clone", body, { responseType: "text" });
  }

  public saveBot(bot: Bot) {
    Helpers.trimRecursiveObj(bot);
    const body = JSON.stringify(bot);
    return this.http.put(this.baseUrl + "bot", body, { responseType: "text" });
  }

  public saveBotsInputMappings(botId: string, lines: DataMapping[]) {
    return this.http.put(this.baseUrl + "bot/" + botId + "/input_mappings", lines, { responseType: "text" });
  }

  public createBotInputMapping(botId: string, line: DataMapping) {
    return this.http.post(this.baseUrl + "bot/" + botId + "/input_mapping", line, { responseType: "text" });
  }

  public updateBotInputMapping(line: DataMapping) {
    return this.http.put(this.baseUrl + `input_mapping/${line.id}`, line, { responseType: "text" });
  }

  public deleteBotInputMapping(id: string) {
    return this.http.delete(this.baseUrl + `input_mapping/${id}`, {responseType: "text"});
  }

  public saveBotsOutputMappings(botId: string, lines: DataMapping[]) {
    return this.http.put(this.baseUrl + "bot/" + botId + "/output_mappings", lines, { responseType: "text" });
  }

  public createBotOutputMapping(botId: string, line: DataMapping) {
    return this.http.post(this.baseUrl + "bot/" + botId + "/output_mapping", line, { responseType: "text" });
  }

  public updateBotOutputMapping(line: DataMapping) {
    return this.http.put(this.baseUrl + `output_mapping/${line.id}`, line, { responseType: "text" });
  }

  public deleteBotOutputMapping(id: string) {
    return this.http.delete(this.baseUrl + `output_mapping/${id}`, {responseType: "text"});
  }

  public createBot(serviceId: string, bot: Bot) {
    Helpers.trimRecursiveObj(bot);
    const body = JSON.stringify(bot);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/bot", body);
  }

  public deleteBot(botId: string) {
    return this.http.delete(this.baseUrl + "bot/" + botId, { responseType: "text" });
  }

  public genereateDefaultApplicantFormAndBotMapping(botId: string, botServiceId: string) {
    return this.http.post(this.baseUrl + "bot/" + botId + "/datamapping/" + botServiceId + "/generate", null);
  }

  public getHistoryPage(botId: string, page: number): Observable<any[]> {
    return this.http.get(this.baseUrl + "bot/" + botId + "/pagedhistory?pageNo=" + page + "&pageSize=12") as Observable<any[]>;
  }

  public revertForm(botId: string, revisionNumber: string): Observable<any> {
    const body = JSON.stringify(revisionNumber);
    return this.http.put(this.baseUrl + "bot/" + botId + "/history/" + revisionNumber, body, { responseType: "text" }) as Observable<any>;
  }

}
